import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin } from "lucide-react";
import SafeExperienceImg from "./SafeExperienceImg";
import TrustBadges from "./TrustBadges";

export default function ExperienceCard({ exp, referralHost }){
  // Fallback cards (no real backend listing) link to the Explore page so the user lands somewhere useful
  const href = exp._fallback
    ? `/explore?city=${encodeURIComponent(exp.city || "")}`
    : `/experience/${exp.experience_id}${referralHost ? `?host=${referralHost}` : ""}`;
  return (
    <Link to={href} data-testid={`exp-card-${exp.experience_id}`}
      className="block group rounded-3xl overflow-hidden bg-[#FFF8EE] shadow-luxury hover:shadow-luxury-lg transition-all">
      <div className="relative aspect-[4/3] overflow-hidden">
        <SafeExperienceImg exp={exp} alt={exp.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
        <div className="absolute top-3 left-3 max-w-[80%]">
          <TrustBadges provider={exp.provider || {}} size="sm" />
        </div>
        <div className="absolute bottom-3 right-3 bg-[#FFF8EE]/95 backdrop-blur rounded-full px-3 py-1 text-xs font-semibold" title="Concierges create complete experiences. Final pricing is custom-quoted.">
          <span className="text-[#071A2D]/55 font-normal mr-1">From</span>${exp.price}
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-medium text-lg leading-tight">{exp.title}</h3>
          <div className="flex items-center gap-1 text-sm">
            <Star size={14} fill="#C9A45C" color="#C9A45C"/>
            <span className="font-medium">{exp.rating?.toFixed?.(1) || "4.9"}</span>
          </div>
        </div>
        <div className="mt-2 flex items-center gap-2 text-xs text-[#064E3B]/70">
          <MapPin size={12}/> {exp.city}, {exp.state} <span>· {exp.duration}</span>
        </div>
      </div>
    </Link>
  );
}
